import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-store-reviews-carousel',
  templateUrl: './custom-store-reviews-carousel.component.html',
  standalone: false,
})
export class CustomStoreReviewsCarouselComponent {
  readonly widgetType: string = 'StoreReviewsCarouselContent';
}
